import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { GetColourPalettesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetColourPalettes as useGetColourPalettesTRPC } from './useGetColourPalettesTRPC';

export const useGetColourPalettes = (skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
    error: graphqlError,
  } = useQuery(GetColourPalettesDocument, {
    fetchPolicy: 'no-cache',
    skip: trpcEnabled || skip,
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
    error: trpcError,
  } = useGetColourPalettesTRPC(skip);

  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: trpcRefetch,
      error: trpcError,
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: graphqlRefetch,
    error: graphqlError,
  };
};
